import { CodeBlock } from "./CodeBlock.tsx";

export const TickRate = () => {
  return (
    <>
      <h3 class="font-bold text-sm uppercase opacity-50 mb-2">
        Network Concepts
      </h3>

      <div class="space-y-4 text-xs">
        {/* PING */}
        <div>
          <h4 class="font-bold text-secondary mb-1">Ping (Latency)</h4>
          <p class="opacity-70 mb-2">
            <b>Travel time</b>{" "}
            for a packet to reach the server and back. Measured in{" "}
            <span class="font-mono text-[10px] bg-base-200 px-1 rounded">
              ms
            </span>.
          </p>
          <div class="alert alert-info bg-info/60 p-2 text-xs border-none">
            <span class="text-info-content">
              Lower is always better. Depends on distance (speed of light) &
              routing.
            </span>
          </div>
        </div>

        <div class="divider my-1 opacity-50"></div>

        {/* TICK RATE */}
        <div>
          <h4 class="font-bold text-primary mb-1">Tick Rate (Frequency)</h4>
          <p class="opacity-70 mb-2">
            How often the server <b>processes</b>{" "}
            inputs and updates the world. Measured in{" "}
            <span class="font-mono text-[10px] bg-base-200 px-1 rounded">
              Hz
            </span>.
          </p>

          {/* DECISION GUIDE */}
          <div class="grid grid-cols-2 gap-2 mb-2">
            <div class="bg-base-200 p-2 rounded hover:bg-base-300 transition-colors">
              <div class="font-bold text-success mb-1">Low (20Hz)</div>
              <div class="opacity-60 text-[10px] leading-tight">
                Minecraft, RPGs. Saves CPU & Bandwidth. Good for slow-paced
                games.
              </div>
            </div>
            <div class="bg-base-200 p-2 rounded hover:bg-base-300 transition-colors">
              <div class="font-bold text-error mb-1">High (60Hz+)</div>
              <div class="opacity-60 text-[10px] leading-tight">
                CS:GO, Valorant. Max precision. High CPU/Net cost.
              </div>
            </div>
          </div>
        </div>

        <div class="divider my-1 opacity-50"></div>

        {/* THE LOOP */}
        <div>
          <h4 class="font-bold text-accent mb-1 opacity-80">The Loop</h4>
          <p class="opacity-70 mb-2">
            What "20Hz" looks like in code:
          </p>
          <CodeBlock
            language="typescript"
            code={`const TICK_MS = 50; // 1000ms / 20Hz

while (serverRunning) {
  const start = Date.now();
  updateGamePhysics();
  broadcastState();

  // Wait for remainder of the 50ms
  await sleep(TICK_MS - (Date.now() - start));
}`}
          />
        </div>

        <div class="divider my-1 opacity-50"></div>

        {/* COMBINED IMPACT */}
        <div>
          <h4 class="font-bold text-accent mb-1">Total Delay</h4>
          <p class="opacity-70 mb-2">
            Why you lag even with 0ms Ping:
          </p>

          <div class="bg-base-200 p-3 rounded font-mono text-[10px] space-y-1">
            <div class="flex justify-between">
              <span class="opacity-50">Ping (Travel):</span>
              <span>20ms</span>
            </div>
            <div class="flex justify-between">
              <span class="opacity-50">Tick Delay (Wait):</span>
              <span>+50ms</span>
            </div>
            <div class="flex justify-between border-t border-base-content/20 pt-1 font-bold text-error">
              <span>Real Lag:</span>
              <span>70ms</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
